import { Text } from "react-native";
import type { TextStyle } from "react-native";
import { colors, typography } from "../theme/tokens";

type Props = {
  children: string;
  /** Optional one-off style override (e.g. spacing tweaks). */
  style?: TextStyle;
  /** Optional color override. Defaults to `textFaint`. */
  color?: string;
};

/**
 * Small uppercase section label. Sits above grouped settings cards on
 * YouScreen, and above content sections on LearnScreen.
 * 11px / 600 / textFaint / letterSpacing 1 / uppercase / mb-3 default.
 *
 * For the larger taupe content section dividers (12px / textLight / icon),
 * use `<SectionTitle>` instead.
 */
export function SectionHeader({ children, style, color }: Props) {
  return (
    <Text
      className="font-dm-sans"
      style={[
        {
          fontSize: typography.sizes.sm,
          fontWeight: "600",
          color: color ?? colors.textFaint,
          letterSpacing: 1,
          textTransform: "uppercase",
          marginBottom: 12,
        },
        style,
      ]}
    >
      {children}
    </Text>
  );
}

export default SectionHeader;
